import debounce from 'debounce';
import { BREAKPOINTS } from '@helpers/breakpoint';

(function () {
  const heroLevel2s = document.querySelectorAll<HTMLElement>('.kf-o-hero--level-2');

  if (!heroLevel2s || heroLevel2s.length === 0) return;

  // Loop through all hero level 2 elements
  heroLevel2s.forEach((heroLevel2) => {
    const heroHeadingContainer = heroLevel2.querySelector<HTMLElement>('.kf-o-hero__header-container');
    const heroFeaturesContainer = heroLevel2.querySelector<HTMLElement>('.kf-o-hero__features-container');
    const heroBackgroundWrapper = heroLevel2.querySelector<HTMLElement>('.kf-o-hero__background-wrapper');

    if (!heroHeadingContainer || !heroFeaturesContainer || !heroBackgroundWrapper) return;

    // Register the heroHeadingContainer to be moved based on screen size
    window.addEventListener(
      'resize',
      debounce(() => {
        const parent = heroHeadingContainer.parentElement;

        if (!parent) return;

        if (window.innerWidth < BREAKPOINTS.DESKTOP) {
          if (parent !== heroBackgroundWrapper) {
            if (!heroHeadingContainer.classList.contains('kf-container')) heroHeadingContainer.classList.add('kf-container');

            heroBackgroundWrapper.append(heroHeadingContainer);
          }
        } else {
          if (parent !== heroFeaturesContainer) {
            if (heroHeadingContainer.classList.contains('kf-container')) heroHeadingContainer.classList.remove('kf-container');

            heroFeaturesContainer.prepend(heroHeadingContainer);
          }
        }
      }, 100)
    );
  });

  // Trigger resize event on load to ensure correct placement
  window.dispatchEvent(new Event('resize'));
})();
